<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="50%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        size="small"
        label-width="120px"
      >
        <el-form-item label="种类名称" prop="typeName">
          <el-input v-model="form.typeName"></el-input>
        </el-form-item>
        <el-form-item label="pcode" prop="pcode" required>
          <el-input v-model="form.pcode"></el-input>
        </el-form-item>
        <el-form-item label="typeCode" prop="typeCode" required>
          <el-input v-model="form.typeCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" type="primary" @click="handleOk"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
// import { listMixin } from '@/mixins/listMixin';

var typeCodeNumber = (rule, value, callback) => {
  if (isNaN(value)) {
    callback(new Error("请输入整数"));
  } else if (value.length < 3 || value.length > 10) {
    callback(new Error("请输入3-10位数的数字"));
  }
  callback();
};
var pcodeNumber = (rule, value, callback) => {
  if (isNaN(value)) {
    callback(new Error("请输入整数"));
  } else if (value.length < 1) {
    callback(new Error("请输入pcode"));
  }
  callback();
}
export default {
  components: {},
  // mixins: [listMixin],
  props: {},
  data() {
    return {
      title: "操作",
      visible: false,
      form: {
        id: "",
        pcode: "",
        typeCode: "",
        typeName: "",
      },
      validatorRules: {
        pcode: [
          {
            validator: pcodeNumber,
            trigger: "blur",
          },
        ],
        typeCode: [
          {
            validator: typeCodeNumber,
            trigger: "blur",
          },
        ],
        typeName: [
          {
            required: true,
            message: "请输入种类名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
      },
      url: {
        queryClassifyInfo: "/wlMallType/queryType/",
        add: "/wlMallType/addType",
        edit: "/wlMallType/editType",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    add() {
      this.edit({});
    },
    async edit(record) {
      console.log(record);
      this.visible = true;
      if (!record.id) return;
      let res = await httpAction(
        this.url.queryClassifyInfo + record.id,
        {},
        "get"
      );
      if (res.code == 200) {
        console.log(res);
        this.form = res.data;
        this.form.id = res.data.id;
        this.form.pcode = res.data.pcode;
        this.form.typeCode = res.data.typeCode;
        this.form.typeName = res.data.typeName;
      } else {
        this.$message.warning(res.msg);
      }
    },
    close() {
      this.visible = false;
      this.form.id = "";
      this.form.pcode = "";
      this.form.typeCode = "";
      this.form.typeName = "";
      this.$refs.form.resetFields();
    },
    handleOk() {
      // 触发表单验证
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log(this.form);
          if (this.title === "新增") {
            let res = await httpAction(this.url.add, this.form, "post");
            if (res.code !== 200) return this.$message.error(res.msg);
            this.$message.success("操作成功");
            this.close();
            this.$emit("ok");
          } else if (this.title === "编辑") {
            let res = await httpAction(this.url.edit, this.form, "post");
            console.log(res);
            if (res.code == 200) {
              this.$message.success("操作成功");
              this.close();
              this.$emit("editOk");
            } else {
              this.$message.warning(res.msg);
            }
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  .menuBar {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    /*height: calc(100% - 100px);*/
    height: 300px;
    overflow-y: auto;
  }
}
</style>
